import { useTheme, IconButton, Paper, Button, ClickAwayListener } from "@mui/material";
import { AttachFile } from "@mui/icons-material";
import { useState } from "react";
import { getNotesSectionsStyles } from "../../../styles/ThemePanel";
import { useGenerateClipping } from "../../../hooks/useClipping/usePostGenerateClipping";
import { postSectionClippingURL } from "../../../utils/ConstantsURL";

export const SectionList = ({
  sections,
  selectedIdSection,
  handleSelect,
  token,
  idDocument,
  selectedDate,
  addToDownloadQueue,
  addToHiperlyncQueue,
}) => {
  const theme = useTheme();
  const classSection = getNotesSectionsStyles(theme);
  const { generateClipping } = useGenerateClipping(token, addToDownloadQueue, addToHiperlyncQueue);
  const [openBubbleId, setOpenBubbleId] = useState(null);

  const handleClipClick = (e, sectionId) => {
    e.stopPropagation();
    setOpenBubbleId(sectionId);
  };

  const handleClipping = (sectionId, sectionName) => {
    generateClipping(
      idDocument,
      selectedDate,
      sectionName,
      true,
      [sectionId],
      () => setOpenBubbleId(null),
      [],
      false,
      postSectionClippingURL
    );
  };

  const handleHiperlink = (sectionId, sectionName) => {
    generateClipping(
      idDocument,
      selectedDate,
      sectionName,
      true,
      [sectionId],
      () => setOpenBubbleId(null),
      [],
      true,
      postSectionClippingURL
    );
  };

  const handleCloseBubble = () => {
    setOpenBubbleId(null);
  };

  return (
    <>
      {sections
        .filter((item) => item.NOMBRE_SECCION !== "PORTADA-PRINCIPAL")
        .map((item) => (
          <div
            key={item.ID_SECCION}
            onClick={() => handleSelect(item.ID_SECCION)}
            style={
              selectedIdSection === item.ID_SECCION
                ? classSection.selectedContainer
                : classSection.itemContainer
            }
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                position: "relative",
              }}
            >
              <div style={classSection.itemName}>
                {item.NOMBRE_SECCION.toLowerCase()}
              </div>
              <IconButton
                size="small"
                onClick={(e) => handleClipClick(e, item.ID_SECCION)}
              >
                <AttachFile fontSize="small" />
              </IconButton>
              {openBubbleId === item.ID_SECCION && (
                <ClickAwayListener onClickAway={handleCloseBubble}>
                  <Paper
                    elevation={4}
                    style={{
                      position: "absolute",
                      top: -14,
                      right: -18,
                      zIndex: 2,
                      padding: 8,
                      display: "flex",
                      flexDirection: "column",
                      gap: 4,
                    }}
                  >
                    <Button
                      size="small"
                      variant="contained"
                      onClick={() => handleHiperlink(item.ID_SECCION,item.NOMBRE_SECCION)}
                    >
                      Hipervínculo
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => handleClipping(item.ID_SECCION, item.NOMBRE_SECCION)}
                    >
                      Clipping
                    </Button>
                  </Paper>
                </ClickAwayListener>
              )}
            </div>
          </div>
        ))}
    </>
  );
};
